import { wrapperCls, iframeCls, headingCls, bodyCls, buttonCls } from './empty.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Empty(props) {
  return /*#__PURE__*/jsxs("div", {
    ref: props.ref,
    className: wrapperCls,
    children: [/*#__PURE__*/jsx("iframe", {
      className: iframeCls,
      "aria-hidden": true,
      sandbox: "allow-scripts",
      src: "https://portalmotor.gyldendal.dk/-/media/home/web/idas-showroom/billeder/InSiteAd/Still-TomOversigt.svg",
      width: 260,
      height: 260,
      frameBorder: 0,
      tabIndex: -1
    }), /*#__PURE__*/jsx("h1", {
      className: headingCls,
      children: "Du har ingen forl\xF8b"
    }), /*#__PURE__*/jsx("p", {
      className: bodyCls,
      children: "Klik p\xE5 \u2018Opret nyt forl\xF8b\u2019 og kom i gang med at bygge og dele indhold"
    }), /*#__PURE__*/jsx("button", {
      className: buttonCls,
      onClick: props.toOnboarding,
      children: "F\xE5 en introduktion"
    })]
  });
}

export { Empty };
//# sourceMappingURL=empty.js.map
